$(document).ready(function() {
    $('#start-now').click(function(){
        $('#step1').show();
        $('#progress').show();
        $('#intro').hide();
    });

    if (window.location.href.indexOf("#customPalette") > -1) {
        $('#customPalette').show();
        $('#progress').show();
        $('#intro').hide();
        $('.progressbar').find('#2').addClass('active');
    }

    if (window.location.href.indexOf("#premadePalette") > -1) {
        $('#premadePalette').show();
        $('#progress').show();
        $('#intro').hide();
        $('.progressbar').find('#2').addClass('active');
    }

    if (window.location.href.indexOf("#step1") > -1) {
        $('#intro').hide();
        $('#step1').show();
        $('#customPalette').hide();
        $('#progress').show();
        $('#premadePalette').hide();
        $('#2').removeClass('active');
    }

    $('#start-now').click(function(){
        $('#step1').show();
        $('#intro').hide();
    });

    $('#selectCustom').click(function(){
        $('#step1').hide();
        $('#customPalette').show();
        $('.progressbar').find('#2').addClass('active');
    });

    $('#selectPremade').click(function(){
        $('#step1').hide();
        $('#premadePalette').show();
        $('.progressbar').find('#2').addClass('active');
    });

    $('#1').click(function(){
        $('#step1').show();
        $('#customPalette').hide();
        $('#premadePalette').hide();
        $('#2').removeClass('active');
    });

    $("#size").change(function () {
        var value = $(this).val();
        if ( value == 'All' ) {
            $(".customPaletteGrid").find('li').show();
        } else {
            $(".customPaletteGrid").find('li').hide();
            $(".customPaletteGrid").find('li[data-size="' + value + '"]').show();
        }
    });
    $("#type").change(function () {
        var value = $(this).val();
        if ( value == 'All' ) {
            $(".premadePaletteGrid").find('li').show();
        } else {
            $(".premadePaletteGrid").find('li').hide();
            $(".premadePaletteGrid").find('li[data-tags*="' + value + '"]').show();
        }
    });
});